import {
  ThemeColor,
  ThemeMode,
  UserPreferences,
} from "@/types/ApiResponses/UserPreferences";
import { api } from "..";

interface UpdatePreferencesPayload {
  themeColor?: ThemeColor;
  themeMode?: ThemeMode;
  showQuickDeposit?: boolean;
  dismissOnboardingSetup?: boolean;
  /** Records Zero's one-time dark default as applied (server ignores the whole
   *  request once the marker is set). */
  applyZeroDarkDefault?: boolean;
}

export const updatePreferences = async (
  payload: UpdatePreferencesPayload
): Promise<UserPreferences> => {
  const res = await api.client.patch("/user-preferences", payload);
  return res.data;
};
